<app-dashboard>
  <div class="w-full flex flex-col items-center p-[20px]">
    <div class="w-full max-w-[800px] flex flex-col">
      <span class="font-[600] text-slate-800 text-[18px] mb-[15px]"
        >Add an {{ newRelay?.type }} Relay</span
      >
      <div
        class="w-full flex flex-col border rounded-[20px] p-[15px] mb-[15px]"
      >
        <app-input
          [label]="'Relay Name'"
          [title]="'name'"
          (returnValue)="handleInput($event)"
          [placeholder]="'Enter name...'"
        />
        <app-input
          [label]="'Destination Domain'"
          [title]="'destinationDomain'"
          [placeholder]="'eg.. https://test.com'"
          (returnValue)="handleInput($event)"
        />
        <app-input
          [label]="'Source IP (comma separated)'"
          [placeholder]="'eg.. 0.0.0.0, 1.1.1.1'"
          (returnValue)="setIpAddresses($event)"
        />
        <app-dropdown [error]="errors.vault" [label]="'Vault'" (selectedValue)="handleInput($event)" [items]="vaultNames" [placeholder]="'Select vault..'" [title]="'vaultId'" />
      </div>
      <div class="w-full">
        <div class="w-full mb-[15px]">
          <span class="text-slate-800 font-[600] text-[18px]">Filters:</span>
        </div>
        <div
          *ngFor="let filter of newRelay.filters; index as filterIndex"
          class="w-full grid grid-cols-[1fr_5%] gap-[5px]"
        >
          <div
            class="w-full flex flex-col mt-[5px] border p-[15px] rounded-[20px]"
          >
            <app-dropdown
              [label]="'Type'"
              [items]="filterType"
              [title]="'type'"
              [placeholder]="'Select option...'"
              (selectedValue)="handleBaseFilterData($event, filterIndex)"
                [error]="errors?.filters?.[filterIndex]?.type"
            />
            <app-select
              [label]="'Actions'"
              [title]="'action'"
              [items]="actionType"
              [value]="newRelay?.filters[0]?.action"
              (selectedValue)="handleBaseFilterData($event, filterIndex)"
              [error]="errors?.filters[filterIndex]?.action"
            />
            <app-dropdown [items]="tokenGenerator" [error]="errors?.filters[filterIndex]?.tokenGenerator" [title]="'tokenGenerator'" [label]="'Token Generator'" (selectedValue)="handleBaseFilterData($event, filterIndex)" />
            <app-select
              [label]="'Storage'"
              [items]="storageType"
              [title]="'storage'"
              (selectedValue)="handleBaseFilterData($event, filterIndex)"
              [error]="errors?.filters[filterIndex]?.storage"
            />
            <app-select
              [label]="'Transformer'"
              [items]="transformers"
              [title]="'transformer'"
              [value]="newRelay?.filters[0]?.transformer"
              (selectedValue)="handleTransformerType($event, filterIndex)"
              [error]="errors?.filters[filterIndex]?.transformer"
            />
            <div>
              <span class="text-[16px] text-slate-800 font-[600]"
                >Fields in {{selectedTransformer}} path:</span
              >
              <div
                *ngFor="
                  let transformer of newRelay?.filters[filterIndex]
                    ?.transformerSelections;
                  index as i
                "
                class="grid grid-cols-[95%_5%] items-center w-full items-center gap-[5px]"
              >
                <app-input
                  [title]="'transformerSelections'"
                  [title]="'selector'"
                  [placeholder]="selectedFieldPlaceholder"
                  (returnValue)="
                    handleTransformerSelections($event, filterIndex, i)
                  "
                  [error]="errors?.filters[filterIndex]?.transformerSelections[i]?.selector"
                />
                <img
                  (click)="removeTransformerSelection(i, filterIndex)"
                  class="cursor-pointer mb-[22px]"
                  src="../../../assets/icons/delete.svg"
                  alt=""
                />
              </div>
              <div (click)="addTransformerSelection(filterIndex)" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mb-[20px] flex justify-center items-center">
                <span class="font-[600] text-[12px] text-gray-500">Add Transformer +</span>
            </div>
            </div>
            <div>
              <span class="text-[16px] text-slate-800 font-[600]"
                >Targets:</span
              >
              <div
                *ngFor="
                  let target of newRelay?.filters[filterIndex]?.targets;
                  index as i; trackBy: trackByFn
                "
                class="grid grid-cols-[95%_5%] items-center w-full items-center gap-[5px]"
              >
              <app-input (returnValue)="handleTarget($event, filterIndex, i)" [title]="'targets'" [error]="errors?.filters[filterIndex]?.targets[i]" />
              <img
                  (click)="removeTarget(i, filterIndex)"
                  class="cursor-pointer mb-[22px]"
                  src="../../../assets/icons/delete.svg"
                  alt=""
                />
              </div>
              <div class="w-full flex justify-end">
                <div (click)="addTarget(filterIndex)" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mb-[20px] flex justify-center items-center">
                    <span class="font-[600] text-[12px] text-gray-500">Add Target +</span>
                </div>
              </div>
            </div>
            <div class="w-full">
              <span class="text-[16px] text-slate-800 font-[600]"
                >Configurations:</span
              >
              <div class="w-full border-b my-[5px]"></div>
              <app-select
                [label]="'Condition'"
                [title]="'condition'"
                (selectedValue)="handleConfig($event, filterIndex)"
                [items]="conditions"
                [error]="errors?.filters?.[filterIndex]?.config?.condition"
              />
              <div
                *ngFor="
                  let rules of newRelay?.filters?.[filterIndex]?.config?.rules;
                  index as i
                "
                class="grid grid-cols-[22%_22%_22%_22%_5%] items-center w-full items-center gap-[10px]"
              >
                <app-dropdown [title]="'field'" [value]="newRelay?.filters[0]?.config?.rules[0]?.field" [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.field"  [placeholder]="'select item...'" (selectedValue)="handleRules($event, filterIndex, i)" [label]="'Field:'" [items]="rulesField" />
                <app-input
                  [label]="'Type:'"
                  [title]="'type'"
                  [placeholder]="'eg.. string'"
                  (returnValue)="handleRules($event, filterIndex, i)"
                  [error]="errors?.filters[filterIndex]?.config?.rules?.[i]?.type"
                />
                <app-dropdown [items]="rulesOperator" [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.operator" [label]="'Operator:'" [title]="'operator'" (selectedValue)="handleRules($event, filterIndex, i)" />
                <app-dropdown
                *ngIf="this.newRelay.filters?.[filterIndex].config.rules?.[i].field !== 'PathInfo' && 
                       this.newRelay.filters?.[filterIndex].config.rules?.[i].field !== 'Status'"
                       [title]="'value'"
                       [label]="'Value:'"
                       (selectedValue)="handleRules($event, filterIndex, i)"
                       [items]="selectedRuleDropdown"
                       [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.value"
              ></app-dropdown>
              
              <app-input
                *ngIf="this.newRelay.filters?.[filterIndex].config.rules?.[i].field === 'PathInfo' || 
                       this.newRelay.filters?.[filterIndex].config.rules?.[i].field === 'Status'"
                [label]="'Value:'"
                [title]="'value'"
                (returnValue)="handleRules($event, filterIndex, i)"
                [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.value"
              ></app-input><img
                  (click)="removeRule(i, filterIndex)"
                  class="cursor-pointer"
                  src="../../../assets/icons/delete.svg"
                  alt=""
                />
              </div>
              <div (click)="addRule(filterIndex)" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mb-[20px] flex justify-center items-center">
                <span class="font-[600] text-[12px] text-gray-500">Add Rules +</span>
            </div>
            </div>
          </div>
          <img
            (click)="removeFilter(filterIndex)"
            class="cursor-pointer mb-[22px] mt-[5px]"
            src="../../../assets/icons/delete.svg"
            alt=""
          />
        </div>
        <div (click)="addFilter()" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mt-[30px] flex justify-center items-center">
            <span class="font-[600] text-[12px] text-gray-500">Add Filter +</span>
        </div>
      </div>
      <app-button
        [label]="'Create Relay'"
        (onClick)="createRelay()"
        [loading]="loading"
        [className]="
          'text-[#fff] w-full h-[50px] mt-[30px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
  </div>
</app-dashboard>
